module.exports = __webpack_public_path__ + "img/ug342.516a1424.png";